import React from 'react';
import { Modal } from 'antd';
import EditInsuranceDefaultWageForm from './EditInsuranceDefaultWageForm';
import { usePersistedStore } from '../../store/persisted-store';
import { useGeneralStore } from '../../store/slices/createGeneralSlice';

export default function EditInsuranceWage() {
    const { business } = usePersistedStore();
    const general = useGeneralStore();
    const visible = general.view.editInsuranceDefaultAgent;
    const selectedBranch = business.wages.single;

    return (
        <Modal
            width={800}
            title="بروزرسانی اطلاعات رشته بیمه"
            className="custom-table"
            visible={visible}
            footer={false}
            onCancel={() => general.ToggleEditInsuranceDefaultAgentModal()}>
            <EditInsuranceDefaultWageForm
                onSubmit={() => {
                    general.ToggleEditInsuranceDefaultAgentModal();
                    general.NotifSuccess('اطلاعات رشته بیمه با موفقیت بروزرسانی شد');
                }}
                branch={selectedBranch}
            />
        </Modal>
    )
}
